import cn from 'classnames';
import React, { useState } from 'react';

import { useTasksStore } from '../../store/useTasksStore';
import { Task } from '../../types/tasks';

export const TextFieldComponent = ({
  task,
  fieldId,
  data,
  disabled,
}: {
  task: Partial<Task>;
  fieldId: string;
  label: string;
  data: string;
  handleDelete: (flag: boolean) => void;
  disabled?: boolean;
}): JSX.Element => {
  const [fieldData, setFieldData] = useState(typeof data === 'string' ? data : '');
  const [isFocused, setIsFocused] = useState(false);

  const onUpdateCustomFieldData = useTasksStore((s) => s.onUpdateCustomFieldData);
  const onUpdateCustomTemplateFieldData = useTasksStore((s) => s.onUpdateCustomTemplateFieldData);

  return (
    <input
      type="text"
      placeholder="Add text"
      className={cn('text-sm text-gray-999 font-regular placeholder-gray-500 h-36 w-400 pl-15', {
        'bg-white rounded-sm border border-gray-200': isFocused,
      })}
      onChange={(e) => {
        setFieldData(e.target.value);
      }}
      readOnly={disabled}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          if (task.id) {
            const payload = { taskId: task.id, fieldId: fieldId, data: fieldData };
            if (task.board?.id === undefined) {
              payload['taskTemplateRef'] = task.id;
              onUpdateCustomTemplateFieldData(payload);
            } else {
              payload['taskTemplateRef'] = undefined;
              onUpdateCustomFieldData(payload);
            }
          }
          setIsFocused(false);
        }
      }}
      onFocus={() => {
        setIsFocused(true);
      }}
      onBlur={() => {
        if (task.id) {
          const payload = { taskId: task.id, fieldId: fieldId, data: fieldData };
          if (task.board?.id === undefined) {
            payload['taskTemplateRef'] = task.id;
            onUpdateCustomTemplateFieldData(payload);
          } else {
            payload['taskTemplateRef'] = undefined;
            onUpdateCustomFieldData(payload);
          }
        }
        setIsFocused(false);
      }}
      value={fieldData}
    />
  );
};
